import { type ComponentProps } from 'react';

export const SearchIcon = (props: ComponentProps<'svg'>) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx="12" cy="11" r="4.5" stroke="currentColor" />
      <path d="M15 15L17 17" stroke="currentColor" strokeLinecap="round" />
    </svg>
  );
};
